import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"text-align":"left"}
}
const _hoisted_2 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-1",
  style: {"text-align":"center"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ordem")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "UND")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-3",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Custo", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Total", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Estoque", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Lotes", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Transf. Lote")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-1",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
], -1)
const _hoisted_22 = {
  class: "ant-col ant-col-xs-1 ant-col-xl-1",
  style: {"text-align":"center","align-content":"center"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ant-col ant-col-xs-2 -ant-col-xl-2" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "ant-col ant-col-xs-6 ant-col-xl-5" }
const _hoisted_27 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_28 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_29 = {
  key: 0,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 1,
  class: "ant-col ant-col-xs-3 ant-col-xl-4"
}
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 2,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 3,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"text-align":"center"}
}
const _hoisted_38 = {
  class: "ant-col ant-col-xs-1 ant-col-xl-1",
  style: {"text-align":"center"}
}
const _hoisted_39 = { class: "acoes-item" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 4,
  class: "ant-row",
  style: {"margin-bottom":"8px"}
}
const _hoisted_43 = {
  class: "ant-col ant-col-xs-24",
  style: {"padding-left":"50px","padding-bottom":"8px","padding-top":"8px"}
}
const _hoisted_44 = { class: "ss-titulo-campo" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24" }
const _hoisted_46 = {
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"margin-left":"40px"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-1",
  style: {"text-align":"center"}
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ordem")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "UND")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-3",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
], -1)
const _hoisted_52 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Custo", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Total", -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Estoque", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 3,
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Lotes", -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-2",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Transf. Lote")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-1",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1)
const _hoisted_67 = { class: "ant-col ant-col-xs-2 -ant-col-xl-2" }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "ant-col ant-col-xs-6 ant-col-xl-5" }
const _hoisted_70 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_71 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_72 = {
  key: 0,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"right"}
}
const _hoisted_73 = ["value"]
const _hoisted_74 = {
  key: 1,
  class: "ant-col ant-col-xs-3 ant-col-xl-4"
}
const _hoisted_75 = ["value"]
const _hoisted_76 = {
  key: 2,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_77 = ["value"]
const _hoisted_78 = {
  key: 3,
  class: "ant-col ant-col-xs-3 ant-col-xl-4",
  style: {"text-align":"left","padding-left":"10px"}
}
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"text-align":"center"}
}
const _hoisted_81 = {
  class: "ant-col ant-col-xs-1 ant-col-xl-1",
  style: {"text-align":"center"}
}
const _hoisted_82 = { class: "acoes-item" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_SelecaoEstoqueRastreabilidade = _resolveComponent("SelecaoEstoqueRastreabilidade")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_form_item, {
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.state.exibirCamposCusto,
                    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.exibirCamposCusto) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Exibir Custo e Total")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "small",
                    style: {"margin-left":"12px"},
                    onClick: _ctx.adicionarMateriaPrimaPadrao,
                    disabled: _ctx.props.statusOrdemProducao > 1
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adicionar Matéria-prima ")
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              (_ctx.state.exibirCamposCusto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.state.exibirCamposCusto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              (!_ctx.state.exibirCamposCusto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true),
              (!_ctx.state.exibirCamposCusto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true),
              _hoisted_20,
              _hoisted_21
            ]),
            (!_ctx.UtilitarioGeral.validaLista(_ctx.computedMateriaPrima))
              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                  key: 0,
                  mensagem: "Nenhuma Matéria-prima Informada!"
                }))
              : (_openBlock(), _createBlock(_component_a_form, {
                  key: 1,
                  name: "ss-form-produto-fornecedores",
                  class: "ss-desabilitar-rolagem-horizontal"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedMateriaPrima, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "ant-row ss-grade-personalizada-linha",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          (item.materiasPrimasPI && item.materiasPrimasPI.length > 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.toggleExpand(index))
                              }, [
                                _createVNode(_component_icone, {
                                  nome: _ctx.isRowExpanded(index) ? 'seta-para-baixo' : 'seta-para-direita'
                                }, null, 8, ["nome"])
                              ], 8, _hoisted_23))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("input", {
                            class: "ant-input",
                            type: "text",
                            value: item.ordem,
                            disabled: "true",
                            style: {"text-align":"center"}
                          }, null, 8, _hoisted_25)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_selecionar_produto, {
                            codigoSelecionado: _ctx.computedMateriaPrima[index].codigoProduto,
                            "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedMateriaPrima[index].codigoProduto) = $event),
                            descricaoSelecionado: _ctx.computedMateriaPrima[index].descricao,
                            "onUpdate:descricaoSelecionado": ($event: any) => ((_ctx.computedMateriaPrima[index].descricao) = $event),
                            empresas: _ctx.props.empresas,
                            modoDefinicaoProduto: true,
                            tipoPCP: true,
                            apresentarCodigoInterno: true,
                            onChange: ($event: any) => (_ctx.limparUnidade(index)),
                            disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                            style: {"text-align":"left"}
                          }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "empresas", "onChange", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_selecionar_unidade_produto_movimento, {
                            codigoProdutoDefinicao: _ctx.computedMateriaPrima[index].codigoProduto,
                            codigoUnidadeSelecionada: _ctx.computedMateriaPrima[index].codigoUnidade,
                            "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((_ctx.computedMateriaPrima[index].codigoUnidade) = $event),
                            empresas: _ctx.props.empresas,
                            sigla: _ctx.computedMateriaPrima[index].siglaUnidade,
                            "onUpdate:sigla": ($event: any) => ((_ctx.computedMateriaPrima[index].siglaUnidade) = $event),
                            apresentarApenasSigla: true,
                            casasDecimais: _ctx.computedMateriaPrima[index].casasDecimais,
                            "onUpdate:casasDecimais": ($event: any) => ((_ctx.computedMateriaPrima[index].casasDecimais) = $event),
                            disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                            style: {"text-align":"center"}
                          }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "empresas", "sigla", "onUpdate:sigla", "casasDecimais", "onUpdate:casasDecimais", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_campo_numerico, {
                            valor: item.quantidade,
                            "onUpdate:valor": ($event: any) => ((item.quantidade) = $event),
                            "quantidade-casas-decimais": item.casasDecimais,
                            disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                            onFocus: ($event: any) => (_ctx.state.quantidadeAnterior = item.quantidade),
                            onChange: ($event: any) => (_ctx.calculaCustoTotal(index)),
                            fracionar: true,
                            style: {"text-align":"right"}
                          }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais", "disabled", "onFocus", "onChange"])
                        ]),
                        (_ctx.state.exibirCamposCusto)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("input", {
                                class: "ant-input",
                                type: "text",
                                value: _ctx.UtilitarioMascara.mascararValor(item.custoUnitario, 2),
                                disabled: "true",
                                style: {"text-align":"right"}
                              }, null, 8, _hoisted_30)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.exibirCamposCusto)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("input", {
                                class: "ant-input",
                                type: "text",
                                value: _ctx.UtilitarioMascara.mascararValor(item.custoTotal, 2),
                                disabled: "true",
                                style: {"text-align":"right"}
                              }, null, 8, _hoisted_32)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.state.exibirCamposCusto)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("textarea", {
                                class: "ant-input",
                                type: "textarea",
                                value: item.estoqueItem ? item.nomeEstoque : 'Não Informado',
                                rows: "1",
                                disabled: "true",
                                style: {"text-align":"left","resize":"none","align-items":"center"}
                              }, null, 8, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.state.exibirCamposCusto)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createElementVNode("textarea", {
                                class: "ant-input",
                                type: "textarea",
                                value: item.lotes ? item.lotes : 'Sem lotes',
                                disabled: "true",
                                rows: "1",
                                style: {"white-space":"pre-wrap","overflow-wrap":"normal","resize":"none","align-items":"center"}
                              }, null, 8, _hoisted_36)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_a_checkbox, {
                            checked: item.transferirLote,
                            "onUpdate:checked": ($event: any) => ((item.transferirLote) = $event),
                            disabled: "true"
                          }, null, 8, ["checked", "onUpdate:checked"])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            (_ctx.props.editarApontamentoMateriaPrima && item.codigo > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.PreparaApontamentoMateriaPrimaParaEdicao(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_40))
                              : _createCommentVNode("", true),
                            (_ctx.props.editavel && item.codigo > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.validarExclusao(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_41))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.isRowExpanded(index) && item.materiasPrimasPI && item.materiasPrimasPI.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, "Detalhamento do Produto Intermediário: " + _toDisplayString(item.descricao), 1)
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _hoisted_47,
                                  _hoisted_48,
                                  _hoisted_49,
                                  _hoisted_50,
                                  _hoisted_51,
                                  (_ctx.state.exibirCamposCusto)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.exibirCamposCusto)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_57))
                                    : _createCommentVNode("", true),
                                  (!_ctx.state.exibirCamposCusto)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                                    : _createCommentVNode("", true),
                                  (!_ctx.state.exibirCamposCusto)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                                    : _createCommentVNode("", true),
                                  _hoisted_64,
                                  _hoisted_65
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.materiasPrimasPI, (subitem, subIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: subIndex,
                                    class: "ant-row ss-grade-personalizada-linha",
                                    style: {"padding":"4px 0","margin-left":"40px"}
                                  }, [
                                    _hoisted_66,
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        value: subitem.ordem,
                                        disabled: "true",
                                        style: {"text-align":"center"}
                                      }, null, 8, _hoisted_68)
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _createVNode(_component_selecionar_produto, {
                                        codigoSelecionado: subitem.codigoProduto,
                                        "onUpdate:codigoSelecionado": ($event: any) => ((subitem.codigoProduto) = $event),
                                        descricaoSelecionado: subitem.descricao,
                                        "onUpdate:descricaoSelecionado": ($event: any) => ((subitem.descricao) = $event),
                                        empresas: _ctx.props.empresas,
                                        modoDefinicaoProduto: true,
                                        apresentarCodigoInterno: true,
                                        onChange: ($event: any) => (_ctx.limparUnidade(index, subIndex)),
                                        disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                                        tipoPCP: true,
                                        style: {"text-align":"left"}
                                      }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "descricaoSelecionado", "onUpdate:descricaoSelecionado", "empresas", "onChange", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                      _createVNode(_component_selecionar_unidade_produto_movimento, {
                                        codigoProdutoDefinicao: subitem.codigoProduto,
                                        codigoUnidadeSelecionada: subitem.codigoUnidade,
                                        "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((subitem.codigoUnidade) = $event),
                                        empresas: _ctx.props.empresas,
                                        sigla: subitem.siglaUnidade,
                                        "onUpdate:sigla": ($event: any) => ((subitem.siglaUnidade) = $event),
                                        apresentarApenasSigla: true,
                                        casasDecimais: subitem.casasDecimais,
                                        "onUpdate:casasDecimais": ($event: any) => ((subitem.casasDecimais) = $event),
                                        disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                                        style: {"text-align":"center"}
                                      }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "empresas", "sigla", "onUpdate:sigla", "casasDecimais", "onUpdate:casasDecimais", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createVNode(_component_campo_numerico, {
                                        valor: subitem.quantidade,
                                        "onUpdate:valor": ($event: any) => ((subitem.quantidade) = $event),
                                        "quantidade-casas-decimais": subitem.casasDecimais,
                                        disabled: !_ctx.props.editarApontamentoMateriaPrima && !_ctx.props.editavel,
                                        onChange: ($event: any) => (_ctx.calculaCustoTotal(index, subIndex)),
                                        fracionar: true,
                                        style: {"text-align":"right"}
                                      }, null, 8, ["valor", "onUpdate:valor", "quantidade-casas-decimais", "disabled", "onChange"])
                                    ]),
                                    (_ctx.state.exibirCamposCusto)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                          _createElementVNode("input", {
                                            class: "ant-input",
                                            type: "text",
                                            value: _ctx.UtilitarioMascara.mascararValor(subitem.custoUnitario, 2),
                                            disabled: "true",
                                            style: {"text-align":"right"}
                                          }, null, 8, _hoisted_73)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.state.exibirCamposCusto)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                          _createElementVNode("input", {
                                            class: "ant-input",
                                            type: "text",
                                            value: _ctx.UtilitarioMascara.mascararValor(subitem.custoTotal, 2),
                                            disabled: "true",
                                            style: {"text-align":"right"}
                                          }, null, 8, _hoisted_75)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_ctx.state.exibirCamposCusto)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          _createElementVNode("textarea", {
                                            class: "ant-input",
                                            type: "textarea",
                                            value: subitem.estoqueItem ? subitem.nomeEstoque : 'Não Informado',
                                            rows: "1",
                                            disabled: "true",
                                            style: {"text-align":"left","resize":"none","align-items":"center"}
                                          }, null, 8, _hoisted_77)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_ctx.state.exibirCamposCusto)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                          _createElementVNode("textarea", {
                                            class: "ant-input",
                                            type: "textarea",
                                            value: subitem.lotes ? subitem.lotes : 'Sem lotes',
                                            disabled: "true",
                                            rows: "1",
                                            style: {"white-space":"pre-wrap","overflow-wrap":"normal","resize":"none","align-items":"center"}
                                          }, null, 8, _hoisted_79)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_80, [
                                      _createVNode(_component_a_checkbox, {
                                        checked: subitem.transferirLote,
                                        "onUpdate:checked": ($event: any) => ((subitem.transferirLote) = $event),
                                        disabled: "true"
                                      }, null, 8, ["checked", "onUpdate:checked"])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                      _createElementVNode("div", _hoisted_82, [
                                        (_ctx.props.editarApontamentoMateriaPrima && subitem.codigo > 0)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.PreparaApontamentoMateriaPrimaParaEdicao(index, subIndex))
                                            }, [
                                              _createVNode(_component_icone, { nome: "editar" })
                                            ], 8, _hoisted_83))
                                          : _createCommentVNode("", true),
                                        (_ctx.props.editavel && subitem.codigo > 0)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              onClick: ($event: any) => (_ctx.validarExclusao(index, subIndex))
                                            }, [
                                              _createVNode(_component_icone, { nome: "excluir" })
                                            ], 8, _hoisted_84))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })),
            _createVNode(_component_SelecaoEstoqueRastreabilidade, {
              visivel: _ctx.state.exibirRastreabilidade,
              "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirRastreabilidade) = $event)),
              empresa: _ctx.props.empresas[0],
              codigoDefinicaoProduto: _ctx.state.codigoProdutoSelecionado,
              itemVenda: _ctx.state.codigoSelecionado,
              quantidade: _ctx.state.quantidade,
              "onUpdate:quantidade": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.quantidade) = $event)),
              tipoLancamento: _ctx.state.tipoLancamento,
              itemEstoque: _ctx.state.codigoItemEstoque,
              lancouRastreabilidades: _ctx.state.lancouRastreabilidades,
              "onUpdate:lancouRastreabilidades": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.lancouRastreabilidades) = $event)),
              recurso: 'PCP_ORDEM_PRODUCAO',
              "estoque-rast-utilizado": _ctx.state.estoqueRastreabilidadeUtilizado,
              "onUpdate:estoqueRastUtilizado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.estoqueRastreabilidadeUtilizado) = $event)),
              tipoRastreabilidade: _ctx.state.tipoRastreabilidade,
              edicao: _ctx.state.edicaoMP,
              onConcluirEdicao: _ctx.EditarApontamentoMateriaPrima
            }, null, 8, ["visivel", "empresa", "codigoDefinicaoProduto", "itemVenda", "quantidade", "tipoLancamento", "itemEstoque", "lancouRastreabilidades", "estoque-rast-utilizado", "tipoRastreabilidade", "edicao", "onConcluirEdicao"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}